module.exports = __webpack_public_path__ + "images/emoji/clock1230.fb854b7594d5c84d8765.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/clock1230.png
// module id = ygh4
// module chunks = 1